<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
    
    <v-progress-linear v-if="loading"
      indeterminate
      class="global-loader"
    ></v-progress-linear>

    <h1 class="primary--text">
      <v-icon color="primary">mdi-bell</v-icon> <span>{{$t('notifications.crumb_title')}}</span>
    </h1>

    <v-btn
      class="float-right"
      :disabled="!canRead"
      color="primary"
      right
      depressed
      @click="readAll"
    >
      {{$t('notifications.mark_read')}}
    </v-btn>

    <v-timeline
      class="mt-15"
      align-top
      :dense="$vuetify.breakpoint.smAndDown"
    >
      <v-timeline-item
        v-for="(item, i) in items"
        :key="i"
        :color="item.read ? 'grey' : item.color"
        :icon="item.icon"
        fill-dot
        large
      >
        <v-card elevation="4" color="gray">
          <v-card-title class="title">
            {{item.title}} 
          </v-card-title>
          <v-card-subtitle>
            {{ item.creation }}
          </v-card-subtitle>
          <v-card-text :class="$root.$vuetify.theme.isDark ? 'text--primary' : 'white text--primary'">
            <p class="pt-2 text-content">{{item.created_at}}</p>
            <p class="pt-2 text-content" v-if="item.type != 'toApprove' && item.type != 'toDo'">
              {{ item.description }}
            </p><p class="pt-2 text-content" v-else-if="item.type == 'shopping-request'">
              {{ item.description }}
            </p>
            <p v-else v-for="(i, index) in computeData(item)" :key="index">
              {{$t('notifications.missing')}}: <a :href="i.url">{{ i.day }}</a>
            </p>
            <v-btn
              v-if="item.type == 'REJECTION'"
              :color="item.read ? 'grey' : 'primary'"
              class="mx-0"
              :class="item.read ? 'btn-readed' : ''"
              depressed
              @click="verDiario(item)"
            >
              {{$t('notifications.check_diary')}}
            </v-btn>
            <v-btn
              v-else-if="item.downloadable"
              :color="item.read ? 'grey' : 'primary'"
              class="mx-0"
              :class="item.read ? 'btn-readed' : ''"
              depressed
              :href="item.url"
            >
              {{$t('globals.download')}}
            </v-btn>
            <p v-else-if="item.type == 'shopping-request'">
              <v-btn color="primary white--text" @click="$router.push('/' + $session.get('domain') + '/admin/shopping-request/' + item.url)">{{$t('notifications.check_request')}}</v-btn>
            </p>
            <p
              v-else-if="item.url != 'null' && !item.downloadable" class="caption">({{$t('notifications.complete')}})</p>
            <v-btn
              v-if="false"
              :color="item.read ? 'grey' : 'primary'"
              class="mx-0"
              :class="item.read ? 'btn-readed' : ''"
              depressed
              :href="item.url"
            >
              {{$t('notifications.create_diary')}}
            </v-btn>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>

    <v-row justify="center">
        <v-btn
          class="mt-12 mb-16"
          :disabled="!hasMore"
          color="primary"
          right
          depressed
          @click="more"
        >
          {{$t('notifications.see_more')}}
        </v-btn>
    </v-row>
    <DialogSuccess :opened="read" @on-ok="read = false" >
      {{$t('notifications.success')}}
    </DialogSuccess>
</section>
</template>

<script>
import DialogSuccess from '@/components/ui/DialogSuccess.vue';
import Notification from "@/api/Notification.js";
export default {
  name: 'TheNotifications',
  created() {
    this.listNotifications();
  },
  components: {
    DialogSuccess,
  },
  data(){
    return {
      loading: true,
      breadcrumbs: [{
        text: 'Dashboard',
        disabled: false,
        href: '/admin',
      },{
        text: 'Notificações',
        disabled: true,
        href: window.location.href,
      }],
      items: [],
      canRead: false,
      hasMore:false,
      read: false,
      offset: 0,
    }
  },
  methods: {
    computeData(item){
        let data = JSON.parse(item.description)
        let returner = [];

        if(item.type == 'toDo'){
          data.forEach(element => {
            

            returner.push({
              'day': element.dia,
              'url':  element.url
            })
          });

        }

        if(item.type == 'toApprove'){
          data.forEach(element => {
            
            returner.push({
              'day': element.date,
              'url':  element.url
            })
          });

        }

        return returner
    },
    notificationDescription(item){
      if(item.type != 'toApprove' && item.type != 'toDo')
        return item.description

      if(item.type == 'toDo'){

        let data = JSON.parse(item.description)
        let txt = ''
        data.forEach(element => {
          
          txt = txt + '<a>- ' + element.dia + "</a>\n\n";
        });
        return txt

      }

      if(item.type == 'toApprove'){
        let data = JSON.parse(item.description)
        let txt = ''
        data.forEach(element => {
          
          txt = txt + '<a>- ' + element.date + "</a>\n\n";
        });
        return txt

      }
    },  
    verDiario(item){
      this.$router.push({ path: 'diaries/search/' + item.url })
    },
    getIcon(notification){

      switch(notification.type){
        case 'xls':
          return {
            icon:'mdi-file-excel',
            color: 'success'
          };
        case 'xml':
          return {
            icon:'mdi-xml',
            color: 'success'
          };
        case 'warning':
          return {
            icon:'mdi-alert',
            color: 'warning'
          };
        default:
          return {
            icon :'comment-text-outline',
            color:'success'
          };
      }
    },
    getButtonName(notification){

      return notification.downloadable ? "Download" : "Ver Mais";
    },
    readAll(){
      this.read = false;

      Notification.read().then(() => {
          this.read = true;

          this.items.forEach(notification => {

            notification.read = true;
            

          });
          this.canRead = false;
          this.$emit('read-notifications')
      });
    },
    listNotifications(){
       Notification.list(0, this.offset).then(({data}) => {
         data.forEach(notification  => {


           let dataObject = new Date(notification.created_at);

           notification.data.creation = dataObject.toLocaleDateString('pt-PT') + ' ' + dataObject.getHours() + ':' + dataObject.getMinutes();

           notification.data.read = notification.read_at != null; 

           notification.data.color = notification.data.read ? "grey" : this.getIcon(notification.data).color; 

           notification.data.icon = this.getIcon(notification.data).icon;

           this.items.push(notification.data);

           this.canRead = notification.data.read ? this.canRead : true;
           
          });
          this.loading = false

        this.hasMore = data.length >= 20;
      });
    },
    more(){
      this.offset+=20;

      this.listNotifications();
    }
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/admin',
          exact: true,
        },
        {
          text: this.$t('notifications.crumb_title'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
}
</script>

<style scoped>
.v-card__title {
  color: #673ab7;
}
.v-card__text {
  background: #15162608 !important;
}
.text-content {
  color:gray
}
.btn-readed {
  color: white;
}
</style>